import { Component, EventEmitter, Output } from "@angular/core";
import { NzModalModule } from "ng-zorro-antd/modal";

@Component({
    selector: 'app-sst-return-deemed-payment-recovery-modal',
    templateUrl: './sst-return-deemed-payment-recovery-modal.component.html',
    standalone: true,
    imports:[
        NzModalModule
    ]
})
export class SstReturnDeemedPaymentRecoveryModalComponent {
    modalVisible = false;
    @Output() readonly confirm = new EventEmitter<boolean>();

    constructor(){}

    show() {
        this.modalVisible = true;
    }

    handleOk() {
        this.confirm.emit(true);
        this.modalVisible = false;
    }

    handleCancel() {
        this.confirm.emit(false);
        this.modalVisible= false;
    }
}